/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { Bar, BarChart, Cell, Legend, Surface, Symbols, Tooltip, XAxis, YAxis } from "recharts";

import { IDemographicsChartProps } from "../IDemographicsChartProps";
import { barCharStyle, COLORS } from "./DemographicsBarChart.styles";

export function DemographicsBarChart(props: IDemographicsChartProps) {
  const { data, title } = props;

  const renderCustomLegend = () => {
    return (
      <>
        {data.map((entry, index) => (
          <div key={`item-${index}`}>
            <Surface width={10} height={10}>
              <Symbols cx={5} cy={5} type="circle" size={50} fill={COLORS[index % COLORS.length]} />
            </Surface>
            <span key={`item-${index}`}>{entry.name}</span>
            <br />
          </div>
        ))}
      </>
    );
  };

  return (
    <div style={barCharStyle}>
      <h5>{title}</h5>
      {data && data.length > 0 ? (
        <BarChart width={800} height={400} data={data} barCategoryGap={10} margin={{ top: 20 }}>
          <XAxis tick={false} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" label={{ position: "top" }}>
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
          <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            content={renderCustomLegend}
          />
        </BarChart>
      ) : (
        <>No Data</>
      )}
    </div>
  );
}
